import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-templates-nav',
  templateUrl: './document-templates-nav.component.html',
  styleUrls: ['./document-templates-nav.component.css']
})
export class DocumentTemplatesNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
